import { useLocation } from 'react-router-dom';

const BLOCKED = [
  { match: ['admin', 'dashboard', 'panel', 'cms', 'backend', 'wp-admin', 'administrator'], icon: '🚫', title: 'Access Blocked', msg: 'This area is restricted and not accessible from this site.' },
  { match: ['login', 'signin', 'auth', 'password', 'account', 'user'], icon: '🔒', title: 'No Login Here', msg: 'There is no user login on this site. Manage via the admin system.' },
  { match: ['api', 'endpoint', 'json', 'graphql', 'rest'], icon: '⛔', title: 'API Not Accessible', msg: 'API endpoints are not publicly accessible.' },
  { match: ['env', '.env', 'config', 'secret', 'key'], icon: '🛡️', title: 'Blocked', msg: 'Configuration files are not accessible.' },
  { match: ['php', 'asp', 'cgi', 'sql', 'db', 'database'], icon: '🛑', title: 'Not Found', msg: 'This server does not run PHP, ASP or expose databases.' },
];

export default function NotFound() {
  const { pathname } = useLocation();
  const lower = pathname.toLowerCase();

  const match = BLOCKED.find(b => b.match.some(k => lower.includes(k)));
  const icon  = match?.icon  || '🔍';
  const title = match?.title || 'Page Not Found';
  const msg   = match?.msg   || `The page "${pathname}" does not exist on this website.`;

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4rem 2rem' }}>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>{icon}</div>
        <h1 style={{ fontSize: '1.75rem', color: 'var(--navy)', marginBottom: '0.5rem' }}>{title}</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>{msg}</p>
        <code style={{ display: 'block', background: '#f3f4f6', padding: '0.4rem 0.8rem', borderRadius: 4, fontSize: '0.8rem', color: '#dc2626', marginBottom: '2rem' }}>{pathname}</code>
        <a href="/" className="btn-primary" style={{ textDecoration: 'none' }}>← Back to Home</a>
      </div>
    </div>
  );
}
